import { Component, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
@Component({
  selector: 'wm-workflow-janus-actions',
  templateUrl: './workflow-janus-actions.component.html',
  styleUrls: ['./workflow-janus-actions.component.scss'],
  standalone: false,
  encapsulation: ViewEncapsulation.None
})
export class WorkflowJanusActionsComponent {
  @Input() row!: any;
  @Input() isEntitledToDisable = false;
  @Input() isEntitledToPublish = false;
  @Input() isEntitledToHistory = false;
  @Input() isEntitledToBuilder = false;
  @Input() isEntitledToStart = false;
  @Input() isEntitledToArchive = false;
  @Output() action = new EventEmitter<{ action: string; row: any }>();

  constructor(private router: Router) {} // Added by Deepak 06/05/2026
  canDisable(): boolean {
    return !this.row.isArchived && this.row.isEnabled;
  }

  canEnable(): boolean {
    return !this.row.isArchived && !this.row.isEnabled;
  }

  onPrimaryClick(event: MouseEvent) {
    event.stopPropagation();
  }

  canStartApplication(): boolean {
    return (
      (!this.row.isArchived &&
        this.row.isEnabled &&
        this.row.isPublished) ||
      (this.row.lastPublishedOnString)
    );
  }

  emit(action: string): void {
    this.action.emit({ action, row: this.row });
  }

  // Navigate to workflow builder with state added by Deepak 06/05/2026
  openBuilder() {
  this.router.navigate(
      ['/admin/workflow-builder', this.row.id],
      {
        state: {
          returnUrl: this.router.url
        },
      }
    );
  }
  // End of code added by Deepak 06/05/2026
}
